import { Router } from "@angular/router";
import { BaseAccountService } from "admin/baseLogin/BaseAccountService";
import { AppConstants } from "admin/utile/AppConstants";

export class BaseCompanySignup
{
    error: string;

    constructor(
        protected router: Router,
        protected accountService: BaseAccountService,
        protected appUrl: string,
        protected accountUrl: string)
    {
    }

    submit(name: string, code: string): void {
        this.accountService.createCompany(name, code).subscribe(
            result => {
                if (result.Success) {
                    this.router.dispose();
                    window.location.replace(AppConstants.baseUrl + this.appUrl);
                    return;
                }

                if (result.Error) {
                    this.error = result.Error;
                }

                console.error(result.Error);
            },
            error => {
                console.error(error);
            }
        );
    }

    logout(): void {
        this.accountService.logout().toPromise().then(
            result => {
                if (result.Success) {
                    this.router.dispose();
                    window.location.replace(AppConstants.baseUrl + this.accountUrl);
                }
            },
            error => {

            }
        );
    }
}